import React, { useCallback } from 'react';
import { EnhancedDropdown } from '../defaultClassComponents.jsx';
import { Dropdown } from 'semantic-ui-react';
import ActionItem from './ActionItem.jsx';
import ActionConfirmation from './ActionConfirmation.jsx';
import ActionTooltip from './ActionTooltip.jsx';

export default function ActionDropdown({
  className,
  zIndex,
  children,
  ...props
}) {
  const isEmpty = useCallback(
    () => !children || (Array.isArray(children) && children.length === 0),
    [],
  );

  return (
    <EnhancedDropdown
      {...props}
      pointing
      className={`action-dropdown ${className || ''}`}
    >
      <Dropdown.Menu style={{ zIndex: zIndex }}>
        {isEmpty() ? (
          <div className='message'>No actions available</div>
        ) : (
          children
        )}
      </Dropdown.Menu>
    </EnhancedDropdown>
  );
}

ActionDropdown.Item = ActionItem;
ActionDropdown.Confirmation = ActionConfirmation;
ActionDropdown.Tooltip = ActionTooltip;
ActionDropdown.defaultProps = {
  text: 'Actions',
  style: {},
};
